<template>
  <div>
    <v-card>
      <v-toolbar>
        <v-btn icon @click="close">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title
          >Редактировать пользователя: {{ user.name }}</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn @click="save"> <v-icon left>save</v-icon>Записать </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-form ref="form" v-model="valid">
          <v-text-field label="Логин" v-model="user.email"> </v-text-field>

          <v-text-field label="Фамилия" v-model="user.famil"> </v-text-field>

          <v-text-field label="Имя" v-model="user.name"> </v-text-field>

          <v-text-field label="Отчество" v-model="user.otch"> </v-text-field>

          <v-text-field label="Контактный Email" v-model="user.emailContact">
          </v-text-field>

          <v-text-field label="№ телефона" v-model="user.phone"> </v-text-field>

          <v-text-field label="Должность" v-model="user.position">
          </v-text-field>

          <v-text-field label="Адрес" v-model="user.address"> </v-text-field>

          <v-text-field label="Краткая информация" v-model="user.bio">
          </v-text-field>

          <v-text-field label="Дата рождения" v-model="user.date">
          </v-text-field>

          <v-checkbox label="Активирован" v-model="user.active"></v-checkbox>
          <v-text-field label="Пароль"> </v-text-field>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="close">Отмена (закрыть)</v-btn>
        <v-btn @click="save">Записать</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import Globalrules from "../../components/api/rules.js";
import Swal from "sweetalert2";
export default {
  data() {
    return {
      loading: false,
      rules: Globalrules,
      error: "",
      valid: true,
      orgPravForm: [
        { name: "Юридическое лицо", id: "1" },
        { name: "Индивидуальный предриниматель ", id: "2" },
      ],
      vidnologObl: [
        { name: "ОСН", id: 1 },
        { name: "УСН", id: 2 },
        { name: "Другая", id: 3 },
      ],
    };
  },
  methods: {
    OnChangeINNLupa() {
      this.loading = true;

      this.$store
        .dispatch("FillByINN", this.organisation)
        .then(() => {
          if (this.$store.getters.getErrorApi == "INNNOTFOUND") {
            Swal.fire({
              icon: "warning",
              title: "ИНН в базе данных отсутствует.",
              text: "Проверьте, правильно ли вы его указали",
            });
          }
          this.loading = false;
        })
        .catch((error) => {
          this.error = error
          this.loading = false;
          Swal.fire({
            icon: "error",
            title: "Что то пошло не так!",
            text: "Мы не нашли такой ИНН",
          });
        });
    },

    close() {
      this.$store.commit("SET_CURRENT_ORGANISATION_UM", {});
      this.$router.push({ name: "usermanagement" });
    },
    save() {},
  },
  computed: {
    user() {
      return this.$store.getters.GetCurrentOrganisationUserUM;
    },
  },
  mounted() {
    this.setTitle(`Редактировать пользователя: ${this.user.name}`);
  },
};
</script>

<style lang="scss"></style>
